import axios from "axios";
import { useQuery } from "react-query";
import { sortBy } from "lodash";
import type { Timefactor } from "src/types/emission";

export function useTimefactors() {
  async function fetchTimefactors() {
    const response = await axios.get<Timefactor[]>("/planning-api/ifdmtimefactors");

    return sortBy(response.data, "serialNumber");
  }

  return useQuery<Timefactor[], Error>(["timefactors"], fetchTimefactors, {
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: false,
  });
}
